var map = {
	"./add-to-cart.svg": 6357,
	"./arrow-down.svg": 3911,
	"./arrow-left.svg": 5768,
	"./arrow-right.svg": 1879,
	"./book.svg": 668,
	"./brush.svg": 7013,
	"./calendar.svg": 8865,
	"./cart.svg": 9177,
	"./circle.svg": 5031,
	"./close.svg": 9077,
	"./delivery.svg": 1739,
	"./earth.svg": 9153,
	"./eco.svg": 4314,
	"./facebook.svg": 7967,
	"./gift.svg": 2281,
	"./hamburger.svg": 4340,
	"./help.svg": 1354,
	"./instagram.svg": 4501,
	"./jupiter.svg": 8998,
	"./loading.svg": 3689,
	"./mars.svg": 3940,
	"./menu.svg": 8490,
	"./mercury.svg": 9294,
	"./minus.svg": 7089,
	"./neptune.svg": 2682,
	"./palette.svg": 8404,
	"./paper.svg": 935,
	"./pen.svg": 2812,
	"./planet.svg": 1509,
	"./plus-minus.svg": 2276,
	"./plus.svg": 2131,
	"./quotation-mark.svg": 9303,
	"./ruler.svg": 7573,
	"./saturn.svg": 9358,
	"./shipping.svg": 9893,
	"./star.svg": 7239,
	"./sun.svg": 7639,
	"./triangle.svg": 363,
	"./twitter.svg": 8888,
	"./uranus.svg": 1875,
	"./venus.svg": 8638,
	"./wallpaper.svg": 6175,
	"./zoom.svg": 5194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1534;